import React from 'react';
import ReactDOM from 'react-dom';
import {ModalWidgetWaiting} from './components.jsx';
import {OSWidgetInt} from '../widget/osWidgetInt.jsx';
//GEGA WTF !!!??

function handleCloseModal() {
    console.log('handleCloseModal...');
}

export function ShowInternalWidget( callingSystem, legacy_order_no, quickSearchData, searchVal )
{
  var Params = {
      lookupType: "legacy_order_no",
      lookupValue: legacy_order_no,
      callingSystem: callingSystem
  }

  ReactDOM.render( <ModalWidgetWaiting size={'large'} />
                  ,document.getElementById('internalWidget')
  );

  $('#ossOrderModal').modal({
      backdrop: 'static'
  });

  GET("/os/ossui/v1/in/widget/order", Params,
      function(resp) {
          //console.log(resp);


          if (resp.status == 'N') {

              alert(resp.message);

          } else {
              //console.log(resp.data);
              // now show everything
              $('#ossOrderModal').modal('hide');

              ReactDOM.render(
                <OSWidgetInt
                  quickSearchResp={quickSearchData}
                  searchVal={searchVal}
                  order={resp.data}/>
                , document.getElementById('internalWidget')
              );
/*              React.renderComponent(
                  OSWidgetInt({
                      quickSearchResp: quickSearchData,
                      searchVal: searchVal,     
                      order: resp.data
                  }),
                  document.getElementById('internalWidget')
              );*/

              $('#ossOrderModal').modal({
                  backdrop: 'static'
              });
          }
      }
  );
}


function InitQuickSearch() {
    $('#quicksearch').keydown(function(e) {
        if (e.keyCode == 13) {
            console.log('handleQuickSearch');
            $("#errorPane").hide();
            $("#errorPaneText").html("");
            e.preventDefault();
            e.stopPropagation();
            var quicksearchVal = $('#quicksearch').val().trim();
            if(quicksearchVal!=""){
                    console.log('searching for', quicksearchVal);
                    ReactDOM.render( <ModalWidgetWaiting size={'large'} /> ,
                      document.getElementById('internalWidget')
                    );
                    $('#ossOrderModal').modal({
                        backdrop: 'static'
                    });
                    var quickSearchUrl = "/os/ossui/v1/in/quickSearch/" + quicksearchVal+"/"+I18N.locale;
                    GET(quickSearchUrl, "",
                        function(quickSearchResp) {
                            console.log(quickSearchResp);

                            if (quickSearchResp.status == 'E') {

                                $("#errorPane").show();
                                $("#errorPaneText").html("An error occured:  " + quickSearchResp.message);

                            } else {
                                //console.log(quickSearchResp.data);
                                if (quickSearchResp.data.length == "0") {

                                    $("#errorPane").show();
                                    $("#errorPaneText").html("An error occured:  " + quickSearchResp.message);

                                } else {
                                    var legacyOrderNo = quickSearchResp.data[0].legacy_order_no;
                                    ShowInternalWidget( 'quicksearch', legacyOrderNo,
                                                         quickSearchResp.data, quicksearchVal);
                                }
                            }
                        }
                    );
                }else{
                    ReactDOM.render( <ModalWidgetWaiting size={'large'} /> ,
                      document.getElementById('internalWidget')
                    );
                    $('#ossOrderModal').modal({
                        backdrop: 'static'
                    });
                    $("#errorPane").show();
                    $("#errorPaneText").html("An error occured:   Invalid search criteria. Please enter order#/po#/ship#/inv# ");
                }
            }
    });
}

export function EnableDropdown() {
    $(function() {
        $('.dropdown').hover(
            function() {
                //$('.dropdown-menu', this).show();
                $(this).toggleClass('open');
            },
            function() {
                //$('.dropdown-menu', this).hide();
                $(this).toggleClass('open');
            }
        );
        $('.navbar-header').hover(
            function() {
                $(this).toggleClass('open');
            },
            function() {
                $(this).toggleClass('open');
            }
        );
        $('.carousel-example-generic').carousel();
    });
}

export function InitOSSMenu() {
  UserSettings.load();  
  EnableDropdown();
}

function extractFromErrorResponse(statusText, responseObj, responseText, defaultErrMsg){
  var errMsg=defaultErrMsg;
  var respMsg="";
  var T=I18N.getLocalizedText;

  if (statusText == "timeout") {
    errMsg=T('warn_timeout');
  } else {
    if (responseObj) {
      if ( typeof responseObj =='object' ) {
        respMsg = responseObj.message || '';
      } else {
        try {
          var responseError = JSON.parse(responseObj);
          respMsg = responseError.message;
        } catch(err) {
          respMsg=responseObj;
        }
      }
      errMsg=T('warn_error_occured') +':  '+ T(respMsg);
     } else {
        errMsg=T('warn_error_occured');
     }
  }

  return errMsg;
}
